export default __webpack_public_path__ + "static/media/VideoCameraSlash_2.747a54f2.svg";